




































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { CollectionEventDetailsModel } from "@/api/CollectionEvents";
import { getCollectionIssueHistory, CollectionIssueEventModel, postCollectionIssueHistoryExport } from "@/api/CollectionIssueHistory";
import CollectionIssueEventDetailsDialog from "@/components/CollectionIssueEvents/CollectionIssueEventDetailsDialog.vue";
import { LoadingStore } from "@/store/loadingStore";
import { Observer } from "mobx-vue";
import notificationStore from "@/store/notificationStore";

@Observer
@Component({ components: { CollectionIssueEventDetailsDialog } })
export default class CollectionIssueHistory extends Vue {
  @Prop(Object) readonly collectionEvent?: CollectionEventDetailsModel;
  issueHistory: CollectionIssueEventModel[] = [];
  headers = [
    { text: "Timestamp", value: "eventDateTimeOffset" },
    { text: "Collection Issue", value: "collectionIssueType" },
    { text: "Waste Stream", value: "wasteStream" },
    { text: "", value: "snapshotPath" }
  ];
  dialog = false;
  selected: CollectionIssueEventModel | null = null;
  loading = new LoadingStore();

  async mounted() {
    await this.fetchData();
  }

  @Watch("collectionEvent")
  private onCollectionEventChange() {
    this.fetchData();
  }

  private async fetchData() {
    if (!this.collectionEvent || !this.collectionEvent.addressStreetName) return;

    const request = {
      addressUnitNo: this.collectionEvent.addressUnitNo,
      addressStreetNo: this.collectionEvent.addressStreetNo,
      addressStreetName: this.collectionEvent.addressStreetName,
      addressSuburbName: this.collectionEvent.addressSuburbName,
      addressStateCode: this.collectionEvent.addressStateCode,
      addressPostCode: this.collectionEvent.addressPostCode,
      addressCountry: this.collectionEvent.addressCountry
    };
    await this.loading.track(async () => {
      try {
        this.issueHistory = await getCollectionIssueHistory(request);
      } catch (error) {
        notificationStore.error("An unexpected error occurred while loading issue history");
      }
    }, "fetchIssues");
  }

  showPhoto(item: CollectionIssueEventModel) {
    this.selected = item;
    this.dialog = true;
  }

  async exportAsCsv() {
    await this.loading.track(async () => {
      if (!this.collectionEvent) return;
      await postCollectionIssueHistoryExport({
        addressUnitNo: this.collectionEvent.addressUnitNo,
        addressStreetNo: this.collectionEvent.addressStreetNo,
        addressStreetName: this.collectionEvent.addressStreetName,
        addressSuburbName: this.collectionEvent.addressSuburbName,
        addressStateCode: this.collectionEvent.addressStateCode,
        addressPostCode: this.collectionEvent.addressPostCode,
        addressCountry: this.collectionEvent.addressCountry
      });
    }, "export");
  }
}
